<template>
  <div class="w-full rounded-2xl overflow-hidden bg-neutral-light relative mt-4" style="min-height: 340px">
    <div :id="mapElId" ref="mapRef" class="w-full h-[340px]"></div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';

const props = defineProps({
  lat: { type: Number, required: true },
  lng: { type: Number, required: true },
  title: { type: String, default: '' },
  address: { type: String, default: '' },
  mapId: { type: String, default: 'property-map' },
});

const mapElId = `map-${props.mapId}-${Math.random().toString(36).substring(2, 9)}`;
const mapRef = ref(null);

let map = null;
let marker = null;
let observer = null;

onMounted(() => {
  if (!window.mapboxgl) {
    console.error('Mapbox GL JS no est\u00e1 cargado.');
    return;
  }

  map = new mapboxgl.Map({
    container: mapElId,
    style: 'mapbox://styles/mapbox/streets-v11',
    center: [props.lng, props.lat],
    zoom: 15,
    attributionControl: false,
  });

  map.scrollZoom.disable();
  map.touchZoomRotate.disable();

  marker = new mapboxgl.Marker({ color: '#DC2C2E' })
    .setLngLat([props.lng, props.lat])
    .setPopup(
      new mapboxgl.Popup({ offset: 25 }).setHTML(
        `<div class="font-title font-bold text-base text-primary-dark mb-1">${props.title}</div>` +
        `<div class="font-sans text-p4 text-neutral-dark">${props.address}</div>`
      ),
    )
    .addTo(map);

  marker.togglePopup();

  observer = new ResizeObserver(() => map.resize());
  observer.observe(mapRef.value);
});

onUnmounted(() => {
  if (observer) observer.disconnect();
  if (map) map.remove();
});
</script>
